import { FunctionComponent } from 'react';
import { oc } from 'ts-optchain';

import { ConsumerPurchaseSummary } from 'generated/graphql';
import { Link } from 'react-router-dom';
import { core } from '@tock/coretypes';
import { getReservationLink } from 'utils/profileUtils';
import ReservationDetails from 'components/profile/ReservationDetails';
import ReservationTitle from 'components/profile/ReservationTitle';

interface Props {
  business: core.IBusinessPublic;
  purchases: ConsumerPurchaseSummary[];
}

const PopUp = ({ business, purchases }: Props) => {
  return (
    <div className="TravelLogMap-infoBox">
      <div className="TravelLogMap-infoBoxScrollArea">
        <div className="TravelLogMap-infoBoxContent">
          {purchases.length === 1 ? (
            <SingleVisitPopUp reservation={purchases[0]} />
          ) : (
            <MultiVisitPopUp business={business} reservations={purchases} />
          )}
        </div>
      </div>
    </div>
  );
};

const SingleVisitPopUp = ({ reservation }: { reservation: ConsumerPurchaseSummary }) => {
  const title = oc(reservation).business.name() || undefined;
  return (
    <div className="TravelLogMap-infoBox-singleVisit">
      <ReservationLink to={reservation}>
        <ReservationDetails reservation={reservation} title={title} size="SMALL" />
      </ReservationLink>
    </div>
  );
};

interface MultiVisitPopUpProps {
  business: core.IBusinessPublic;
  reservations: ConsumerPurchaseSummary[];
}

const MultiVisitPopUp = ({ business, reservations }: MultiVisitPopUpProps) => {
  if (reservations.length === 0) {
    return <div />;
  }
  const businessName = oc(business).name() || undefined;
  return (
    <div>
      <div className="TravelLogMap-infoBox_multivisitTitle">
        <div className="TravelLogMap-infoBox_visitsText">{reservations.length} visits</div>
        {businessName && <ReservationTitle title={businessName} />}
      </div>
      {reservations.map((reservation) => (
        <div
          key={`reservation-${reservation.id}`}
          className="TravelLogMap-infoBox_multivisitReservation"
        >
          <ReservationLink to={reservation}>
            <ReservationDetails reservation={reservation} size="SMALL" />
          </ReservationLink>
        </div>
      ))}
    </div>
  );
};

interface ReservationLinkProps {
  to: ConsumerPurchaseSummary;
}

const ReservationLink: FunctionComponent<ReservationLinkProps> = ({ to, children }) => {
  const manageLink = getReservationLink(to);
  if (!manageLink) {
    return <>{children}</>;
  } else {
    return (
      <Link to={manageLink} style={{ textDecoration: 'none' }}>
        {children}
      </Link>
    );
  }
};

export default PopUp;
